import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "button", "menu" ]

  connect() {
    this.closeOtherMenu = (event) => {
      if (event.detail !== this.element) this.close()
    }

    window.addEventListener("sidebar-user-menu:open", this.closeOtherMenu)
  }

  disconnect() {
    window.removeEventListener("sidebar-user-menu:open", this.closeOtherMenu)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    this.menuTarget.hidden ? this.open() : this.close()
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  keydown(event) {
    if (event.key !== "Escape" || this.menuTarget.hidden) return

    this.close()
    this.buttonTarget.focus()
  }

  open() {
    window.dispatchEvent(new CustomEvent("sidebar-user-menu:open", { detail: this.element }))
    this.menuTarget.hidden = false
    this.buttonTarget.setAttribute("aria-expanded", "true")
    this.element.classList.add("is-open")
  }

  close() {
    this.menuTarget.hidden = true
    this.buttonTarget.setAttribute("aria-expanded", "false")
    this.element.classList.remove("is-open")
  }
}
